import React, { useEffect } from 'react';
import { useObserver } from "mobx-react";
import { RequestStatus, stores } from 'mobx-store';
import { AddAccumulationProps } from './types';
import {
    translate,
  } from '../../helperFunctions/translation';
import { useParams } from 'react-router';
import { Card, CardContent, CircularProgress } from '@material-ui/core';
import StateFullContainer from 'components/stateFullContainer';
import { RenewalRecord } from 'mobx-store/storeInterfaces/renewals.interface';
import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
const UserRenewalsScreen: React.FC<AddAccumulationProps> = (props: AddAccumulationProps) => {
    const {
        userManagementStore
    } = stores;
    const { userId } = useParams<{userId: string}>();

    useEffect(() => {
        userManagementStore.getUserRenewals(+userId);
    },[userId]);

    const RenewalAmount = (props: {state: RequestStatus}) => (
        <StateFullContainer state={props.state}>
             <Card>
                <CardContent>
                    Total Amount: {userManagementStore?.renewalsDetails?.renewals?.totalAmount}
                </CardContent>
            </Card>
        </StateFullContainer>
    );

    const RenewalsTable = (props: {state: RequestStatus}) => (
        <GeneralTableComponent
        emptyMessage={translate('settingsListNoSettingsMessage')}
        title={"Renewals"}
        tableHeader={[
          {
            title: 'Renewal Title'
          },
          {
            title: 'Document Code',
          },
          {
            title: 'Renewal Category Code',
          },
          {
            title: 'Renewal Category Name',
          },
          {
            title: 'Renewal Comp Code'
          },
          {
            title: 'Renewal Document DueDate'
          },
          {
            title: 'Renewal Amount'
          }
        ]}
        tableData={
            userManagementStore?.renewalsDetails?.renewals?.records
        }
        tableCellTypes={[
          {
            key: 'renewalTitle',
            cellType: 'Text'
          },
          {
            key: 'renewalDocumentCode',
            cellType: 'Text',
          },
          {
            key: 'renewalCategoryCode',
            cellType: 'Text',
          },
          {
            key: 'renewalCategoryName',
            cellType: 'Text',
          },
          {
            key: 'renewalCompCode',
            cellType: 'Text',
          },
          {
            key: 'renewalDocumentDueDate',
            cellType: 'Text'
          },
          {
            key: 'renewalAmount',
            cellType: 'Text'
          }
        ]}
        loadingStatus={[
          userManagementStore.state,
        ]}
      />
    );

    return useObserver(() => (
        <div>
            <RenewalAmount state={userManagementStore.state} />
            <RenewalsTable state={userManagementStore.state} />
        </div>
    ));
}
export default UserRenewalsScreen;